import React, {Component} from "react";
import {connect} from "react-redux";
import {Menu} from "antd";
import {Link} from "react-router-dom";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";

import Auxiliary from "util/Auxiliary";
import UserProfile from "./UserProfile";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE
} from "../../constants/ThemeSetting";
import IntlMessages from "../../util/IntlMessages";

const SubMenu = Menu.SubMenu;

class SidebarContent extends Component {

  getNoHeaderClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      return "gx-no-header-notifications";
    }
    return "";
  };
  getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return "gx-no-header-submenu-popup";
    }
    return "";
  };

  render() {
    const {themeType, navStyle, pathname, user, history} = this.props;
    const selectedKeys = pathname.substr(1);
    const defaultOpenKeys = selectedKeys.split('/')[1];
    return (<Auxiliary>

        <SidebarLogo/>
        <div className="gx-sidebar-content">
          <div className={`gx-sidebar-notifications ${this.getNoHeaderClass(navStyle)}`}>
            <UserProfile user={user} userName={user.name} image={user.image}/>
          </div>
          <CustomScrollbars className="gx-layout-sider-scrollbar">
            <Menu
              defaultOpenKeys={[defaultOpenKeys]}
              selectedKeys={[selectedKeys]}
              theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
              mode="inline">

              <Menu.Item key="clientDashboard">
                <Link to="/clientDashboard">
                  <i className="icon icon-widgets"/>
                  <IntlMessages id="sidebar.home"/></Link>
              </Menu.Item>

              <SubMenu key="affiliates" className={this.getNavStyleSubMenuClass(navStyle)}
                      title={<span> <i className="icon icon-company"/>
                      <IntlMessages id="sidebar.affiliates"/></span>}>

                <Menu.Item key="clientDashboard/affiliatesList">
                  <Link to="/clientDashboard/affiliatesList">
                    <i className="icon icon-plain-list-divider"/>
                    <IntlMessages id="sidebar.affiliatesList"/></Link>
                </Menu.Item>

                <Menu.Item key="clientDashboard/affiliatesRequest">
                  <Link to="/clientDashboard/affiliatesRequest">
                    <i className="icon icon-inbox"/>
                    <IntlMessages id="sidebar.affiliatesRequest"/></Link>
                </Menu.Item>

                <Menu.Item key="clientDashboard/affiliatesInvitations">
                  <Link to="/clientDashboard/affiliatesInvitations">
                    <i className="icon icon-feedback"/>
                    <IntlMessages id="sidebar.affiliatesInvitations"/></Link>
                </Menu.Item>

              </SubMenu>
              
              <SubMenu key="orders" className={this.getNavStyleSubMenuClass(navStyle)}
                      title={<span> <i className="icon icon-orders"/>
                      <IntlMessages id="sidebar.orders"/></span>}>   

                <Menu.Item key="clientDashboard/ordersAdd">
                  <Link to="/clientDashboard/ordersAdd">
                    <i className="icon icon-add-circle"/>
                    <IntlMessages id="sidebar.ordersAdd"/></Link>
                </Menu.Item>        
                           
                <Menu.Item key="clientDashboard/ordersList">
                  <Link to="/clientDashboard/ordersList">
                    <i className="icon icon-plain-list-divider"/>
                    <IntlMessages id="sidebar.ordersList"/></Link>
                </Menu.Item>

                <Menu.Item key="clientDashboard/ordersComplete">
                  <Link to="/clientDashboard/ordersComplete">
                    <i className="icon icon-check-circle-o"/>
                    <IntlMessages id="sidebar.ordersComplete"/></Link>
                </Menu.Item>

                <Menu.Item key="clientDashboard/ordersWaiting">
                  <Link to="/clientDashboard/ordersWaiting">
                    <i className="icon icon-circle-o"/>
                    <IntlMessages id="sidebar.ordersWaiting"/></Link>
                </Menu.Item>

                <Menu.Item key="clientDashboard/ordersCancelled">
                  <Link to="/clientDashboard/ordersCancelled">
                    <i className="icon icon-close-circle"/>
                    <IntlMessages id="sidebar.ordersCancelled"/></Link>
                </Menu.Item>   

                {/* <Menu.Item key="clientDashboard/ordersEdit">
                  <Link to="/clientDashboard/ordersEdit">
                    <i className="icon icon-feedback"/>
                    <IntlMessages id="sidebar.ordersEdit"/></Link>
                </Menu.Item> */}

              </SubMenu>

              <SubMenu key="invoices" className={this.getNavStyleSubMenuClass(navStyle)}
                      title={<span> <i className="icon icon-listing-dbrd"/>
                      <IntlMessages id="sidebar.invoices"/></span>}>

                <Menu.Item key="clientDashboard/invoices">
                  <Link to="/clientDashboard/invoices">
                    <i className="icon icon-listing-dbrd"/>
                    <IntlMessages id="sidebar.invoicesList"/></Link>
                </Menu.Item>

              </SubMenu>

            </Menu>
          </CustomScrollbars>
        </div>
      </Auxiliary>
    );
  }
}

SidebarContent.propTypes = {};
const mapStateToProps = ({ user:{ user } , settings, routing}) => {
  const {navStyle, themeType, locale, pathname} = settings;
  return {navStyle, themeType, locale, pathname, user, routing}
};
export default connect(mapStateToProps)(SidebarContent);

